import React from 'react';

/**
 * Marca do BenDesk: "B" com headset, recriado em vetor limpo (mesmo "B" do
 * favicon). Usa currentColor — a cor vem da classe de texto do pai.
 */
export function BenDeskLogoMark({ className = '', size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {/* headband */}
      <path d="M11 25a13 13 0 0 1 26 0" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
      {/* earcups */}
      <rect x="7.5" y="24" width="6.5" height="12.5" rx="3.25" fill="currentColor" />
      <rect x="34" y="24" width="6.5" height="12.5" rx="3.25" fill="currentColor" />
      {/* mic boom */}
      <path d="M37.25 36.5q0 6.5-7 6.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      <circle cx="29" cy="43" r="2.3" fill="currentColor" />
      {/* B (mesmo glifo do favicon) */}
      <text
        x="24"
        y="33.7"
        textAnchor="middle"
        fontFamily="Inter, system-ui, sans-serif"
        fontWeight="800"
        fontSize="21"
        fill="currentColor"
      >
        B
      </text>
    </svg>
  );
}

/**
 * Logo completo: badge azul (igual favicon) com a marca B+headset branca +
 * wordmark "Ben"(claro) "Desk"(azul). Cores via classes Tailwind, theme-aware.
 */
export default function BenDeskLogo({
  className = '',
  markSize = 40,
  markClassName = 'text-white',
  wordClassName = 'text-foreground',
  deskClassName = 'text-primary',
  tagClassName = 'text-muted-foreground',
  showTagline = true,
  badge = true,
  badgeClassName = 'bg-gradient-to-br from-blue-500 to-blue-700 shadow-xl ring-1 ring-black/5',
}) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {badge ? (
        <div
          className={`inline-flex items-center justify-center rounded-2xl ${badgeClassName} ${markClassName}`}
          style={{ padding: `${Math.round(markSize * 0.24)}px` }}
        >
          <BenDeskLogoMark size={markSize} className="shrink-0" />
        </div>
      ) : (
        <BenDeskLogoMark size={markSize} className={`shrink-0 ${markClassName}`} />
      )}
      <div className="leading-none">
        <div className="font-extrabold tracking-tight" style={{ fontSize: `${markSize * 0.62}px` }}>
          <span className={wordClassName}>Ben</span>
          <span className={deskClassName}>Desk</span>
        </div>
        {showTagline && (
          <div
            className={`mt-1.5 font-semibold uppercase ${tagClassName}`}
            style={{ fontSize: `${Math.max(9, markSize * 0.17)}px`, letterSpacing: '0.18em' }}
          >
            ITSM &amp; Help Desk
          </div>
        )}
      </div>
    </div>
  );
}
